function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import chroma from "chroma-js";
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
export var buildStyle = function(param) {
    var backgroundColor = param.backgroundColor;
    return {
        base: {
            position: 'fixed',
            height: '100%',
            width: '100%',
            backdropFilter: 'blur(2px)',
            backgroundColor: backgroundColor.surface && chroma(backgroundColor.surface).alpha(0.8).css(),
            top: 0,
            left: 0,
            display: 'flex',
            boxSizing: 'border-box'
        }
    };
};
export var useStyle = function(param) {
    var zIndex = param.zIndex;
    var styles = useBuildStyleWithTheme(buildStyle);
    return {
        base: _objectSpread({}, styles === null || styles === void 0 ? void 0 : styles.base, {
            zIndex: zIndex
        })
    };
};
